import {storage, firestore} from '../main';
import {mapActions, mapGetters} from 'vuex';
import QBMediaRecorder from 'media-recorder-js'
import RecordRTC from 'recordrtc'
import moment from 'moment'


export default {

    methods: {
        ...mapActions(['setResult']),
        cancelRecord() {
            this.audioRecorder.stop();
        },
        sendFakeRequest() {
            let blob = new Blob(["Cold request", new Date()], {type: "text/plain;charset=utf-8"});
            storage.ref(`audio/cold_refresh/refresh.txt`).put(blob);
            navigator.mediaDevices.getUserMedia({
                video: false,
                audio: {
                    channelCount: 1,
                    echoCancellation: false
                }
            })
        },
        recordDone() {
            this.isRecording = false;
            this.audioRecorder.stopRecording(() => {
                let blob = this.audioRecorder.getBlob();
                this.id = moment().format('YYYYMMDDHHmmss') + "_" + Math.random().toString(36).substr(2, 9)
                blob = new Blob([blob], {type: 'audio/mp3'})
                storage.ref(`production/${this.id}.mp3`).put(blob);
                this.recordIsCompleted = true;
                firestore.collection('all_model_predictions').doc(this.id).onSnapshot(res => {
                    if (res.data()) {
                        this.setResult(res.data());
                    }
                })
            })

        },
        record() {
            this.isStart = false;
            this.isRecording = true;
            let nav = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({
                    video: false,
                    audio: {
                        channelCount: 1,
                        echoCancellation: false
                    }
                }).then(stream => {
                    this.audioRecorder = RecordRTC(stream, {
                        type: 'audio',
                        mimeType: 'audio',
                        recorderType: RecordRTC.StereoAudioRecorder
                    });
                    this.audioRecorder.startRecording();
                })
            } else {
                alert('browser not support plz open with chrome or safari')
            }

        }
    },
    data() {
        return {
            recordIsCompleted: false,
            isStart: false,
            isRecording: false,
            recordingData: [],
            audioSourceNode: {},
            audioRecorder: {},

        }
    },
    created() {
        this.setResult({
            progress: {
                progress_percent: 0
            },
            status: {
                status_code: 0
            }
        })
    }
}
